import { select, takeLatest } from '@redux-saga/core/effects'
import { put } from 'redux-saga/effects'
import { getPatientDemographicsOptionsSelector } from '../selectors/patientDemographicsOptions.selector'
import { setEmailDetails } from '../../patientDemographics/store/patientDemographics.actions'
import { getPatientDemographicsSelector } from '../../patientDemographics/selectors/getPatientDemographics.selector'
import { OptionsConstants } from '../store/options.constants'
import { IPatientDemographicsOptionsState } from '../store/options.types'
import { IPatientDemographicsState } from '../../patientDemographics/store/patientDemographics.types'

export function* setEmailAddress() {
  const patientDemographicsOptions: IPatientDemographicsOptionsState = yield select(
    getPatientDemographicsOptionsSelector
  )
  const patientDemographics: IPatientDemographicsState = yield select(getPatientDemographicsSelector)
  const selectedEmail = patientDemographics?.emailDetails.filter(
    (email) => email.key === patientDemographicsOptions?.emailDetail?.key
  )
  if (selectedEmail && selectedEmail.length) {
    selectedEmail[0].address = patientDemographicsOptions?.email
    yield put(setEmailDetails(patientDemographics?.emailDetails))
  }
}

export function* setEmailAddressSaga() {
  yield takeLatest([OptionsConstants.SET_EMAIL], setEmailAddress)
}
